import * as React from 'react';

import type {IconProps} from '../icon/svg-icon-wrapper';
import {Body} from '../typography/body';
import {Title} from '../typography/title';

import styles from './message-group.module.css';

type Props = {
    /** This should be a component that takes a `size` prop */
    icon?: React.ComponentType<IconProps>;
    /** Optional illustration component that can be used instead of an icon */
    illustration?: React.ReactElement<any>;
    /** Optional title to include on first line */
    title?: string | React.ReactNode;
    /** Body text of the message */
    text?: React.ReactNode;
    /** Optional max width of text. */
    maxWidth?: number | null | undefined;
};

/**
 * Use this component to give the user some kind of message.  It could
 * be a CTA inside a CTA banner, or a success message that something went well.
 * It can (should) have an icon on the left, a title, and a short line of text.
 */
export function MessageGroup(props: Props) {
    const {icon: Icon, illustration, title, text, maxWidth} = props;

    return (
        <div className={styles.message}>
            {illustration}
            {Icon && !illustration ? (
                <div className={styles.icon}>
                    <Icon size={36} wrapWithDiv={false} />
                </div>
            ) : undefined}
            {/* @ts-expect-error */}
            <div style={{maxWidth}} className={styles.text}>
                {title ? <Title>{title}</Title> : undefined}
                {text ? <Body>{text}</Body> : undefined}
            </div>
        </div>
    );
}
